export default __webpack_public_path__ + "static/media/support-notes-main-mexico-business.1e8ee4f7.png";